import { gql } from '@apollo/client';

export const INITIALIZE_STORYBOARD_IMAGE_GENERATION = gql`
  mutation INITIALIZE_STORYBOARD_IMAGE_GENERATION($scenario: String!) {
    initializeStoryboardImageGeneration(scenario: $scenario) {
      messageId
    }
  }
`;
